import { useContext } from 'react'

import { Box, Button, Icon, Text } from '@fairfashion/design-system'

import { OriginItemsContext } from '../../origin-items.context'

import * as Styles from './item-header.styles'

export const ItemHeader = () => {
  const { originItem, actions } = useContext(OriginItemsContext)
  return (
    <Styles.Card>
      <Box width="100%" alignItems="center">
        <Box flex={1} alignItems="center" gap={2}>
          <Styles.IconContainer>
            <Icon name="shapes" size={24} color="purple" />
          </Styles.IconContainer>
          <Text fontWeight={500}>Dados do item</Text>
        </Box>
        <Box>
          <Button
            width="200px"
            variant="outlined"
            onClick={() => actions.setTab('sheet')}
          >
            <Box gap={1} alignItems="center">
              <Text color="secondary" fontWeight={500}>
                Enviar Planilha
              </Text>
              <Icon name="upload" color="secondary" />
            </Box>
          </Button>
        </Box>
      </Box>
      <Styles.Container width="100%">
        <Box direction="column">
          <Text size="small" color="grey_3">
            Item
          </Text>
          <Styles.DescriptionText size="small" fontWeight={500} width="300px">
            {originItem?.description}
          </Styles.DescriptionText>
        </Box>
        <Box direction="column">
          <Text size="small" color="grey_3">
            Marca
          </Text>
          <Text size="small" fontWeight={500}>
            {originItem?.brand?.name}
          </Text>
        </Box>
        <Box direction="column">
          <Text size="small" color="grey_3">
            Quantidade
          </Text>
          <Text size="small" fontWeight={500}>
            {originItem?.quantity} {originItem?.taxUnit}
          </Text>
        </Box>
        <Box direction="column">
          <Text size="small" color="grey_3">
            Código
          </Text>
          <Text size="small" fontWeight={500}>
            {originItem?.code}
          </Text>
        </Box>
        <Box direction="column">
          <Text size="small" color="grey_3">
            NF
          </Text>
          <Text size="small" fontWeight={500}>
            {originItem?.invoice?.code}
          </Text>
        </Box>
        <Box direction="column">
          <Text size="small" color="grey_3">
            Cliente
          </Text>
          <Text size="small" fontWeight={500}>
            {originItem?.client?.name}
          </Text>
        </Box>
        <Box direction="column">
          <Text size="small" color="grey_3">
            CNPJ
          </Text>
          <Text size="small" fontWeight={500}>
            {originItem?.client.taxId}
          </Text>
        </Box>
      </Styles.Container>
    </Styles.Card>
  )
}
